import { useNavigate } from '@tanstack/react-router'
import { SiteViewAssetVizWrapper } from 'features/overview/components/assetVizPanel/SiteViewAssetVizWrapper'
import React, { FC, useState } from 'react'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import styled from 'styled-components'
import {
  GeckoAssetModel,
  GeckoComponent,
  GeckoComponentDataFrame,
  RolodexEntryType,
} from 'types'

const Panel = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  background-color: rgba(0, 0, 0, 0.3);

  transition:
    width 200ms,
    height 200ms;

  &:hover {
    width: 250px;
    height: 250px;
  }
`

const NavigateLink = styled.div`
  cursor: pointer;
  position: absolute;
  left: 0;
  bottom: 0;
  height: 40px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 20px;
  text-align: center;
  line-height: 40px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }
`

export const SiteViewAssetVizPanel: FC<{
  selectedAssetModel: GeckoAssetModel
  selectedComponent: GeckoComponent
  selectedCDF: GeckoComponentDataFrame
  siteID: string
  orgID: string | undefined
  useAssetLifecycle: boolean
  style?: React.CSSProperties
}> = ({
  selectedAssetModel,
  selectedComponent,
  selectedCDF,
  siteID,
  orgID,
  useAssetLifecycle,
  style,
}) => {
  const navigate = useNavigate()
  const [isHovered, setIsHovered] = useState(false)
  const unitID = selectedAssetModel.tags[RolodexEntryType.UNIT]

  const navigateToFullDetails = () => {
    if (useAssetLifecycle && unitID && orgID) {
      navigate({
        to: '/assets/lifecycle',
        search: {
          [SEARCH_PARAM_ORG_ID]: orgID,
          [SEARCH_PARAM_SITE_ID]: siteID,
          [SEARCH_PARAM_UNIT_ID]: unitID,
        },
      })
      return
    }

    navigate({
      to: '/details/$entryID',
      from: '/overview/',
      params: { entryID: selectedComponent.id },
      search: { cdf: selectedCDF.id },
    })
  }

  return (
    <Panel
      style={style}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <SiteViewAssetVizWrapper
        selectedAssetModel={selectedAssetModel}
        selectedComponent={selectedComponent}
        selectedCDF={selectedCDF}
      />
      {isHovered && (
        <NavigateLink onClick={navigateToFullDetails}>
          See full details -{'>'}
        </NavigateLink>
      )}
    </Panel>
  )
}
